<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2eyHIT/tc-custom/9783956766558_IMGJPG_FrontCover_0.jpg?1703129402702" alt="This image is the cover for the book Second Variety, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Second Variety, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Philip Kindred Dick (December 16, 1928 – March 2, 1982) was an American novelist, short story writer, essayist and philosopher whose published work is almost entirely accepted as being in the science fiction genre. Dick explored sociological, political and metaphysical themes in novels dominated by monopolistic corporations, authoritarian governments, and altered states. Philip K. Dick’s 1953 short story "Second Variety" posits the ramifications of a human propensity for playing God, and for mankind’s wanton disregard of the consequences of its technological innovations. (Excerpt from Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip K. Dick
      </h2>
      
      <p class="authorDescription body article">Philip Kindred Dick (December 16, 1928 – March 2, 1982) was an American writer known for his work in science fiction. His work explored philosophical, social, and political themes, with stories dominated by monopolistic corporations, alternative universes, authoritarian governments, and altered states of consciousness. His writing also reflected his interest in metaphysics and theology, and often drew upon his life experiences in addressing the nature of reality, identity, drug abuse, schizophrenia, and transcendental experiences.  (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB-ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5172e4a4